import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useCallback, useEffect, useState } from 'react';
import { BwjToastEvents, IShowToastArgs } from '../../services/toast';
import { BwjBreadSlice } from './bread-slice';
import { IBwjShowToastDialogArgs, PRIVATE_TOAST_DIALOG } from './dialog';
import { BwjEventArgs } from '../../entities/bwj-event';
import { any, remove } from '../../utils/collection';
import { useTransientStatefulEventNotification } from '../../services/event-notification';

interface IBwjToasterProps {
  ariaShowFullMessageLabel: string;
  ariaDismissLabel: string;
  closeDialogButtonText: string;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    position: 'fixed',
    boxSizing: 'border-box',
    bottom: '4.5rem',
    left: 'calc(50% - 400px)',
    width: 800,
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '0.5rem',
    zIndex: 20,

    '@media(max-width: 832px)': {
      width: 'calc(100% - 4rem)',
      left: '2rem',
    },
  };

  const toaster: IStyle = {
    width: '100%',
    maxWidth: 800,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '0.5rem',
  };

  return mergeStyleSets({
    root,
    toaster,
  });
}

const subscriberId = 'Component.BwjToaster';
/*
const testSlices: IShowToastArgs[] = [{
  id: 1,
  type: MessageBarType.info,
  message: 'Here is some info'
}, {
  id: 10,
  type: MessageBarType.success,
  message: 'Something good happened.  How good? Oh so good.  You see, there is no place like home.  When you know you are loved you are never alone.  Or something like that'
}, {
  id: 200,
  type: MessageBarType.warning,
  message: 'You better take it easy bro...'
}];
//*/

export const BwjToaster: React.FunctionComponent<IBwjToasterProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const [launchDialog, setLaunchDialog] = useState<BwjEventArgs<IBwjShowToastDialogArgs> | undefined>(undefined);
  const [loaf, setLoaf] = useState<IShowToastArgs[]>([]);
  const loadToast = useTransientStatefulEventNotification<IShowToastArgs>(BwjToastEvents.ShowToast, subscriberId);
  const popToast = useTransientStatefulEventNotification<number>(BwjToastEvents.DismissToast, subscriberId);

  const onShowFullMessage = (content: IShowToastArgs, icon: string) => {
    setLaunchDialog(new BwjEventArgs({ content, icon }));
  }

  const onDismissMessage = useCallback((id: number) => {
    if(any(loaf, slice => slice.id === id)) {
      const nuLoaf = remove(loaf, slice => slice.id === id);
      setLoaf(nuLoaf);
    }
  }, [loaf]);

  // event handlers
  useEffect(() => {
    if(!loadToast || loadToast.inaccessible()) { return; }
    setLoaf([...loaf, loadToast.getArgs()]);
  }, [loadToast, loaf]);

  useEffect(() => {
    if(!popToast || popToast.inaccessible()) { return; }
    onDismissMessage(popToast.getArgs());
  }, [popToast, onDismissMessage]);

  return (
    <>
    <PRIVATE_TOAST_DIALOG
      launchDialog={launchDialog}
      closeDialogButtonText={props.closeDialogButtonText}
    />
    <div className={cs.root}>
      {loaf.map(slice =>
        <BwjBreadSlice
          key={slice.id}
          content={slice}
          onShowFullMessage={onShowFullMessage}
          onDismissMessage={onDismissMessage}
          ariaShowFullMessageLabel={props.ariaShowFullMessageLabel}
          ariaDismissLabel={props.ariaDismissLabel}
        />
      )}
    </div>
    </>
  );
};